import { IconSunDown, IconSunUp, IconWeather } from '../../../../../assets/icons';

export const mockWeatherData = {
  temperature: 22,
  condition: 'sunny',
  humidity: 65,
  windSpeed: 12,
  sunrise: '05:47',
  sunset: '20:15',
  cloudCover: 15,
  solarRadiation: 'highSolarRadiation',
};

export const getEnergyAdvice = (weatherData: typeof mockWeatherData) => {
  const currentHour = new Date().getHours();

  if (weatherData.solarRadiation === 'highSolarRadiation' && currentHour >= 10 && currentHour <= 16) {
    return {
      type: 'optimal',
      icon: <IconSunUp />,
      color: '#4CAF50',
    };
  }

  if (weatherData.cloudCover > 70) {
    return {
      type: 'moderate',
      icon: <IconWeather />,
      color: '#FF9800',
    };
  }

  if (currentHour >= 17 || currentHour <= 6) {
    return {
      type: 'evening',
      icon: <IconSunDown />,
      color: '#2196F3',
    };
  }

  return {
    type: 'standard',
    icon: <IconSunUp />,
    color: '#4CAF50',
  };
};
